"use client";

import React, { createContext, useEffect, useRef, useState } from "react";

import { usePathname } from "next/navigation";

export const PreviousPathnameContext = createContext("");

export function PreviousPathnameProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const currentPathnameRef = useRef<string>("");
  const [previousPathname, setPreviousPathname] = useState<string>("");

  useEffect(() => {
    setPreviousPathname(currentPathnameRef.current);
    currentPathnameRef.current = pathname;
  }, [pathname]);

  return (
    <PreviousPathnameContext.Provider value={previousPathname}>
      {children}
    </PreviousPathnameContext.Provider>
  );
}
